import yachtsApiService from '@/services/api/Yachts'

const CLASS = 'App\\Yacht'

const STATUS_DRAFT = 'draft'
const STATUS_PENDING = 'pending'
const STATUS_PLANNED = 'planned'
const STATUS_DELIVERY = 'delivery'
const STATUS_IN_USE = 'in_use'
const STATUS_PHASED_OUT = 'phased_out'

const INVESTMENT_STATUS_DRAFT = 'draft'
const INVESTMENT_STATUS_SALES = 'sales'
const INVESTMENT_STATUS_APPROVAL = 'approval'
const INVESTMENT_STATUS_APPROVED = 'approved'
const INVESTMENT_STATUS_RESERVED = 'reserved'
const INVESTMENT_STATUS_SOLD = 'sold'

const emptyFilters = {
  id: null,
  name: null,
  country_id: null,
  hull_number: null,
  yacht_model_id: null,
  owner_id: null,
  total_price_from: null,
  total_price_to: null,
  status: null,
  statuses: null,
  investment_status: null,
  delivery_year: null,
  ex_factory_year: null,
  my_yachts: false,
  my_sales: false,
  finance_model_type: null,
  phase_out_year: null,
  sales_rep_id: null,
  organisation_id: null
}

const emptyModel = {
  id: null,
  name: null,
  hull_number: null,
  factory_id: null,
  yacht_model_id: null,
  owner_id: null,
  status: STATUS_DRAFT,
  investment_status: INVESTMENT_STATUS_DRAFT,
  country_id: null,
  flag_country_id: null,
  destination_base_id: null,
  current_base_id: null,
  production_year: null,
  base_purchase_price: 0,
  base_sale_price: 0,
  base_invoiced_price: 0,
  cdr_price: 0,
  cdr_purchase_price: 0,
  equipment_purchase_price: 0,
  equipment_sale_price: 0,
  total_purchase_price: 0,
  production_year_price_increase: 0,
  total_sale_price: 0,
  total_sale_price_final: 0,
  partners_visible: false,
  currency: 'EUR',
  finance_model_id: null,
  finance_model_params: null,
  finance_model_calculation: null,
  agreement_details: {
    reservation: {
      amount: null,
      due_date: null
    },
    first_payment: {
      payments: [
        {
          amount: null,
          dueDate: null
        }
      ]
    },
    special_deals: null,
    operational_terms: null
  },
  delivery_plan: null,
  delivery_due_at: null,
  delivery_year: null,
  ex_factory_date: null,
  phase_in_date: null,
  phase_out_date: null,
  engine_serial_numbers: [],
  equipment_packs: [],
  is_already_ordered: false,
  editable_fields: ['name', 'hull_number', 'factory_id', 'equipment_packs', 'country_id', 'yacht_model_id', 'owner_id', 'flag_country_id', 'destination_base_id', 'ex_factory_date', 'delivery_year', 'partners_visible']
}

const STATUS_DATA = {
  [STATUS_DRAFT]: {
    color: 'grey darken-1',
    hexColor: '#757575',
    label: 'Draft',
    key: STATUS_DRAFT
  },
  [STATUS_PENDING]: {
    color: 'red',
    hexColor: '#F44336',
    label: 'Pending Plan',
    key: STATUS_PENDING
  },
  [STATUS_PLANNED]: {
    color: 'blue-grey',
    hexColor: '#607d8b',
    label: 'Planned',
    key: STATUS_PLANNED
  },
  [STATUS_DELIVERY]: {
    color: 'brown',
    hexColor: '#795548',
    label: 'In Delivery',
    key: STATUS_DELIVERY
  },
  [STATUS_IN_USE]: {
    color: 'primary',
    hexColor: '#2196f3',
    label: 'In Charter',
    key: STATUS_IN_USE
  },
  [STATUS_PHASED_OUT]: {
    color: 'grey',
    hexColor: '#6c6c6c',
    label: 'Phased Out',
    key: STATUS_PHASED_OUT
  }
}

const INVESTMENT_STATUS_DATA = {
  [INVESTMENT_STATUS_DRAFT]: {
    color: 'grey darken-1',
    label: 'Draft',
    key: STATUS_DRAFT
  },
  [INVESTMENT_STATUS_SALES]: {
    color: 'blue',
    label: 'In Sales',
    key: INVESTMENT_STATUS_SALES
  },
  [INVESTMENT_STATUS_APPROVAL]: {
    color: 'red',
    label: 'Approval',
    key: INVESTMENT_STATUS_APPROVAL
  },
  [INVESTMENT_STATUS_APPROVED]: {
    color: 'blue-grey',
    label: 'Approved',
    key: INVESTMENT_STATUS_APPROVED
  },
  [INVESTMENT_STATUS_RESERVED]: {
    color: 'orange darken-4',
    label: 'Reserved',
    key: INVESTMENT_STATUS_RESERVED
  },
  [INVESTMENT_STATUS_SOLD]: {
    color: 'green',
    label: 'Sold',
    key: INVESTMENT_STATUS_SOLD
  }
}

class Yacht {
  constructor() {
    this.api = yachtsApiService
    this.emptyModel = emptyModel
    this.emptyFilters = emptyFilters
    this.CLASS = CLASS

    this.statusData = STATUS_DATA
    this.investmentStatusData = INVESTMENT_STATUS_DATA

    this.STATUS_DRAFT = STATUS_DRAFT
    this.STATUS_PENDING = STATUS_PENDING
    this.STATUS_PLANNED = STATUS_PLANNED
    this.STATUS_DELIVERY = STATUS_DELIVERY
    this.STATUS_IN_USE = STATUS_IN_USE
    this.STATUS_PHASED_OUT = STATUS_PHASED_OUT

    this.INVESTMENT_STATUS_DRAFT = INVESTMENT_STATUS_DRAFT
    this.INVESTMENT_STATUS_SALES = INVESTMENT_STATUS_SALES
    this.INVESTMENT_STATUS_APPROVAL = INVESTMENT_STATUS_APPROVAL
    this.INVESTMENT_STATUS_APPROVED = INVESTMENT_STATUS_APPROVED
    this.INVESTMENT_STATUS_RESERVED = INVESTMENT_STATUS_RESERVED
    this.INVESTMENT_STATUS_SOLD = INVESTMENT_STATUS_SOLD
  }

  allStatuses() {
    return Object.keys(this.statusData).map((key) => {
      return {
        text: this.statusData[key].label,
        value: key
      }
    })
  }

  allInvestmentStatuses() {
    return Object.keys(this.investmentStatusData).map((key) => {
      return {
        text: this.investmentStatusData[key].label,
        value: key
      }
    })
  }
}
let yacht = new Yacht()

export default yacht
